'use client';

import { useEffect } from 'react';
import { sendDataLayerEvent } from '@utils/send-data-layer-event/send-data-layer-event';

/**
 * @description Fires a GA4 sign_up event via dataLayer once if a short-lived cookie flag exists, then deletes the cookie.
 * Cookie format: ga_signup = encodeURIComponent("1;method")
 */
export const useGaSignUpOnce = (cookieName = 'ga_signup') => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const raw = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`));
    if (!raw) return;

    try {
      const val = decodeURIComponent(raw.split('=')[1]); // e.g. "1;email"
      const [, methodRaw] = val.split(';');
      const method = (methodRaw || 'email').trim();

      // Push to dataLayer using the existing utility
      sendDataLayerEvent({
        event: 'sign_up',
        method,
      });
    } finally {
      // Delete cookie to avoid duplicate firing on refresh/back
      document.cookie = `${cookieName}=; Max-Age=0; path=/`;
    }
  }, [cookieName]);
};
